@if (loading) {
  <div class="loader-overlay">
    <div class="linear"></div>
    <!-- <div class="loader"></div> -->
  </div>
}

@if (roundLoader) {
  <div
    class="loader-round my-4 z-3 rounded position-absolute tw-left-[50%] tw-top-[50%] tw-w-16 tw-h-16"
  ></div>
}
